import React from "react";
import { object, string, number, func, bool } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import Headline from "../../atoms/Headline";
import { staticTexts } from "../../utils/Translate";
import { getExcerpt, getStoryHeadline } from "../../utils/utils";

import "./numberedStoryItem.m.css";

const NumberedStoryItem = ({
  story,
  itemNumber,
  clicked,
  className = "",
  publisherAttributes,
  updatedFont = false,
}) => {
  const excerpt = getExcerpt(story, 100);
  const sectionNameStyle = publisherAttributes.lang === "en" ? "en-section-name" : "section-name";
  const storyHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";
  const storyExcerptStyle = updatedFont ? `${publisherAttributes.lang}-story-excerpt` : "";
  const storyHeadline = getStoryHeadline(story);

  return (
    <div styleName="numbered-story-item" className={className} onClick={clicked}>
      <div
        styleName={`item-number ${publisherAttributes.lang === "en" ? "en-item-number" : ""}`}
        className="item-number"
      >
        {staticTexts(publisherAttributes.lang).NUMBER_ARRAY[itemNumber + 1]}
      </div>
      {global.deviceWidth > 875 && (
        <div styleName="item-container">
          <Link href={story.sections[0]["section-url"]}>
            <Headline
              text={story.sections[0]["display-name"]}
              headlineType={39}
              headerLevel={3}
              className={sectionNameStyle}
              styleName={sectionNameStyle}
            />
          </Link>
          {storyHeadline && (
            <Headline
              text={storyHeadline}
              headlineType={3}
              headerLevel={2}
              className="story-headline"
              styleName={storyHeadlineStyle}
            />
          )}
          {excerpt && (
            <Headline
              text={excerpt}
              headlineType={6}
              headerLevel={4}
              className="sub-headline"
              styleName={storyExcerptStyle}
              dangerouslySet={true}
            />
          )}
        </div>
      )}
    </div>
  );
};

NumberedStoryItem.propTypes = {
  className: string,
  story: object,
  itemNumber: number,
  clicked: func,
  publisherAttributes: object,
  updatedFont: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], null),
});

export default connect(mapStateToProps, null)(NumberedStoryItem);
